import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 28,
  },
});

const LogoIcon = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 31 23"
      fill="none"
    >
      <circle cx="4.10713" cy="11.5002" r="4.10713" fill="white" />
      <circle cx="11.4316" cy="18.8928" r="4.10713" fill="white" />
      <circle cx="18.8242" cy="11.5002" r="4.10713" fill="white" />
      <circle cx="26.3403" cy="4.10713" r="4.10713" fill="white" />
    </svg>
  );
};

export default LogoIcon;
